import React from 'react';

import { Skeleton } from 'native-base';
import { StyleSheet, Text } from 'react-native';

import Currency from 'components/currency';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';

import { useCheckoutState } from '../../checkout-provider';
import { useCheckoutLoadingState } from '../../hooks';

export const GrandTotalText = () => {
  const [{ tipLoading, totals }] = useCheckoutState();
  const { isOrderPriceLoading } = useCheckoutLoadingState();

  if (tipLoading) {
    return <Text style={styles.totalText}>{t('loading')}</Text>;
  }

  if (isOrderPriceLoading) {
    return <Skeleton style={styles.grandTotalSkeleton} />;
  }

  return (
    <Text style={styles.totalText}>
      {t('total') + ': '}
      <Currency
        testID="grand-total"
        amount={totals?.grandTotal}
        isBold
        textProps={{
          color: primitive.bk.$bbqBrown,
          margin: 0,
          flexGrow: 0,
          fontSize: primitive.fontSizes.xl,
        }}
      />
    </Text>
  );
};

const styles = StyleSheet.create({
  totalText: {
    fontSize: primitive.fontSizes.xl,
    color: primitive.bk.$bbqBrown,
    fontFamily: primitive.fontFamily.$headers,
  },
  grandTotalSkeleton: {
    height: 16,
    width: 120,
    alignSelf: 'center',
    color: Styles.color.grey.four,
    marginBottom: 12,
    borderRadius: 100,
  },
});
